import EnlilDetail from "../../../../components/EnlilDetail";
import EventBus from "../../../../util/EventBus";
import Applet from "../../Applet";

class AdminWorkGroupOrganizationFormApplet extends Applet {
    state = {
        Name: "AdminWorkGroupOrganizationFormApplet",
        Modes: {
            View: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "USID",
                            }
                        ]
                    }
                ]
            },
            New: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "USID",
                            }
                        ]
                    }
                ]
            },
            Edit: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "USID",
                            }
                        ]
                    }
                ]
            }
        },
        Layout: {
            totalWidth: "36em",
        },
        Controls: {
            USID: {
                id: "USID",
                enterpriseComponentAttribute: "USID",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "Name",
                    margin: "dense",
                    disabled: false,
                },
                ip: {},
                type: "Select",
                requiresConfirmation: false,
            }
        }
    };

    cancel() {
        super.cancel();

        EventBus.components.emit("admin-work-group-organization-form-applet-cancel");
    };

    setMode(mode) {
        super.setMode(mode);

        if (mode === "Save Completed") {
            EventBus.components.emit("admin-work-group-organization-form-applet-save");
        }
    };

    render() {
        return <EnlilDetail applet={this}
                                layout={this.state.Layout}
                                controls={this.state.Controls}
                                modes={this.state.Modes}
                                title="Organization"
                                enterpriseComponent={this.getEnterpriseComponent()}
                                mode={this.props.defaultMode}
                                errorReportingMethod="RealTime" />;
    }
}

export default AdminWorkGroupOrganizationFormApplet;
